import React from 'react';

import './style.css';

/**
 * Кнопка "Записаться"
 * @class
 * @param {*} props параметры кнопки
 */
const SignUp = (props) => (
  <div className="sign-up">
    <button className="sign-up_btn" onClick={props.click}>Записаться на мастер-класс</button>
  </div>
)

export default SignUp;
